import styled from 'styled-components';

export default styled.svg`
  width: 100%;
  height: 100%;
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/DeviceIcon/DeviceIconSVG.tsx